import React, { FC } from 'react'
import { Tooltip } from 'react-tooltip'

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  tooltipId?: string
  tooltipText?: string
}

export const AiAssistantMessageActionBtn: FC<Props> = ({
  tooltipId,
  tooltipText,
  children,
  ...props
}) => {
  return (
    <>
      <button
        data-tooltip-id={tooltipId}
        data-tooltip-content={tooltipText}
        data-tooltip-place="top"
        {...props}
      >
        {children}
      </button>

      {/* Tooltip */}
      <Tooltip id={tooltipId} delayShow={1000} />
    </>
  )
}
